import React from 'react'
import { generatePath, useLocation, useNavigate } from 'react-router-dom'
import { Box, SvgIcon, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import AngleLeftIcon from '@hapana/shared/web/styles/assets/svgs/angle-left-small.svg'
import Button from '../../button/button.component'
import { BUTTON_VARIANTS } from '../../../../components/shared/button/button.constants'
import { capitalizeFirstLetter } from '@hapana/shared/utils/string.util'

import { styles } from './mobile-breadcrumbs.styles'
import {
  generateNewPath,
  getPathSegments,
  getSecondLastSegment,
} from './mobile-breadcrumbs.constant'

// Route prefixes and UUIDs should show entity name instead of the raw segment
const ROUTE_PREFIXES = new Set(['c', 's'])
const UUID_REGEX = /^[0-9a-f]{8}[-\s][0-9a-f]{4}[-\s][0-9a-f]{4}[-\s][0-9a-f]{4}[-\s][0-9a-f]{12}$/i
const isSystemSegment = (segment) => {
  if (!segment) {
    return false
  }
  const normalized = segment.replace(/\s/g, '-')
  return ROUTE_PREFIXES.has(normalized) || UUID_REGEX.test(segment) || UUID_REGEX.test(normalized)
}

const MobileBreadCrumbs = ({ entityName }) => {
  const location = useLocation()

  const navigate = useNavigate()

  const pathSegments = getPathSegments(location?.pathname)

  const secondLastSegment = getSecondLastSegment(pathSegments)

  const newPath = generateNewPath(location?.pathname)

  const handleNavigate = () => {
    navigate(generatePath(newPath))
  }

  // If the second-to-last segment is a route prefix (c, s) or a UUID, show entity name instead
  const backLabel = isSystemSegment(secondLastSegment)
    ? entityName
    : capitalizeFirstLetter(secondLastSegment)

  const renderMobileBreadcrumbs = () => {
    return (
      <Box sx={styles.navigationLinkContainer}>
        <Typography typography="header3" color="gray.40">
          {entityName}
        </Typography>
        {pathSegments?.length > 1 && (
          <Button
            variant={BUTTON_VARIANTS.TEXT}
            onClick={handleNavigate}
            sx={styles.navigationButton}
          >
            <SvgIcon component={AngleLeftIcon} sx={styles.angleLeftIcon} />
            {backLabel}
          </Button>
        )}
      </Box>
    )
  }
  return <Box>{renderMobileBreadcrumbs()}</Box>
}

MobileBreadCrumbs.propTypes = {
  entityName: PropTypes.string,
}

export default MobileBreadCrumbs
